/**
 * Created by pskwira on 29.08.2018.
 */

define(['jquery', 'lodash', 'eventEmitter/EventEmitter',  '../../utils', '../store/favouriteStore', '../favourites/favourites'], function($, _, EventEmitter, Utils, FavouriteStore, Favourites){

    var config = {
        calculateFormSelector: "#calculationForm",
        calculateFormResetSelector: "#calculationFormReset",
        calculateBtnSelector: "#priceCalculator",
        calculateOverlaySelector: "#calculatorOverlay",
        calculateOverlayRangeSelector: "#rowRange",
        overlayCloseBtnSelector: ".overlay__header__close__calculator",
        singleCalculation: false,
        currentIdentifier: undefined,
        failedRowWrapper: '#failed-row',
        errorResponse: '.response-error',
        errorAreaTooLarge: '.error-area-to-large',
        errorAreaTooLargeEmailId: '#emailcontact400',
        errorAreaTooLargeCountry: '.country-email'
    };

    function PriceCalculator(layoutInstace){

        this.favs = new Favourites();

        this.layoutInstace = layoutInstace;
        this.bindEvents();

    }

    PriceCalculator.prototype = _.clone(EventEmitter.prototype);

    PriceCalculator.prototype.init = function(){

        var _this = this;

        this.favourtiesStore = new FavouriteStore();

        this.resetObj = {
            "country": '',
            "zip": '',
            "area": ''
        };
        this.reset = false;

        this.routeUrl = '';

        var fav = this.favourtiesStore.getFavourites()

        if ( fav.dashboard ) {
            $('input#zip').val(fav.dashboard['zip']);
            $('input#area').val(fav.dashboard['size']);
            $('select#country').val(fav.dashboard['country']);
            $('select#country').material_select();
        }

    };

    PriceCalculator.prototype.bindEvents = function(){

        var _this = this;

        const calculatePriceTrigger = document.getElementById('calculatePrice');
        const calculatePrice = (event) => {
            event.preventDefault();
            const $button = $(calculatePriceTrigger);
            if ($button.attr('disabled')) return;

            const validForm = _this.verifyFormFields();
            if (validForm) {
                disableButtonActionState($button, 'add');
                config.singleCalculation = true;
                config.currentIdentifier = $button.attr('data-product-identifier');

                _this.processSingle().then(function () {
                    disableButtonActionState($button, 'remove');
                }, function () {
                    disableButtonActionState($button, 'remove');
                });
            }
        }

        if (calculatePriceTrigger) {
            calculatePriceTrigger.addEventListener('click', calculatePrice)
        }

        const calculatePricesTrigger = document.getElementById('calculatePrices');
        const calculatePrices = (event) => {
            event.preventDefault();
            const $button = $(calculatePricesTrigger);
            if ($button.attr('disabled')) return;

            $(config.errorResponse).hide();
            $(config.errorAreaTooLarge).hide();
            $(config.errorAreaTooLargeCountry).hide();

            if (_this.verifyFormFields()) {
                disableButtonActionState($button, 'add');

                config.singleCalculation = false;

                _this.processAll().then(function () {
                    disableButtonActionState($button, 'remove');
                }, function () {
                    disableButtonActionState($button, 'remove');
                });
            }
        }

        if (calculatePricesTrigger) {
            calculatePricesTrigger.addEventListener('click', calculatePrices)
        }

        $(document).on({
            click: function (e) {

                e.preventDefault();

                $('#calculationForm input[type=number]').each( function(index, element) {
                    $(element).val('');
                });

                $('#rowRange').hide();

                $(config.calculateFormResetSelector).hide();
                console.log('priceCalculator: 127', 'here')

            }
        }, '#calculationFormReset');

        const validateFormFields = (event) => {
            let reset = 0;
            const formField = event.currentTarget;
            const parent = formField.parentElement;

            $("[data-favourites-prices]").hide();
            $("[data-favourites-asterisk]").hide();

            if (formField.id == 'area' && parent) {
                if (formField.value >= 10 && formField.value < 401) {
                    formField.classList.remove('invalid')
                    formField.classList.add('valid')
                } else {
                    formField.classList.add('invalid')
                    formField.classList.remove('valid')
                }
            }

            if (formField.classList.contains('invalid')) {
                parent.classList.add('input-field--error')
            } else {
                parent.classList.remove('input-field--error')
            }

            const validFormFields = Array.from(document.querySelectorAll('#calculationForm .valid'));
            if (validFormFields.length > 0) {
                $(config.calculateFormResetSelector).show();
            } else {
                $(config.calculateFormResetSelector).hide();
                console.log('priceCalculator: 160', 'hide')
            }
        }
        const formFields = Array.from(document.querySelectorAll('#calculationForm input'));
        formFields.forEach((formField) => {
            formField.addEventListener(
                'change',
                validateFormFields
            )
        })

        function disableButtonActionState($buttonReference, action){

            switch(action){
                case 'add':
                    $buttonReference.attr('disabled', 'disabled');
                    break;
                case 'remove':
                    $buttonReference.removeAttr('disabled');
                    break;
            }
        }

    };

    PriceCalculator.prototype.processSingle = function(){

        var _this = this;

        var favourites = this.favourtiesStore.getFavourites();
        var produtcsContent = favourites['content']['products'];

        var item = $('#calculatorOverlay').find('.favourites__action__wrapper');


        var calculateAllPromise = Utils.createPromise();

        if ( produtcsContent.length == 0 ) {
            _this.emit('favourites:beforecalculation:insert', item[0]);
        } else {

            var itemExist = false;

            $.each(produtcsContent, function (index, value) {
                if ( value.identifier == config.currentIdentifier ) {
                    const gradingScaleFilter = $('.filter_box.filter__grading-scale');
                    var productSorting = gradingScaleFilter.find('.value__selected').get(0);
                    const sorting = productSorting ? $(productSorting).attr('data-items-value') : '';
                    if( value.many ) {
                        if ( value['selected']['wood'] == sorting ) {
                            itemExist = true;
                        }
                    } else {
                        itemExist = true;
                    }
                }
            });

            if ( itemExist ) {

                return _this.calculateSingle().then(function(){
                    calculateAllPromise.resolve();
                    return calculateAllPromise
                }, function(){

                    calculateAllPromise.resolve();
                    return calculateAllPromise
                });

            } else {
                _this.emit('favourites:beforecalculation:insert', item[0]);
            }

        }

        calculateAllPromise.resolve();
        return calculateAllPromise

    }

    PriceCalculator.prototype.calculateSingle = function(){
        var calculateAllPromise = Utils.createPromise();

        return this.calculateAll(this.processForm());
    }

    PriceCalculator.prototype.processAll = function(){
        var favourites = this.favourtiesStore.getFavourites();
        var produtcsContent = favourites['content']['products'];

        $(produtcsContent).each( function(index, element) {
            element['productCombinationId'] = $("#product").find("[data-fav-id='" + element.identifier + "']").data('product-slug')
            if (!element['productCombinationId']) {
                console.error('Could not retrieve productCombinationId', 1610973755);
            }
        })

        this.favourtiesStore.setFavourites(favourites);
        return this.calculateAll(this.processForm());
    };

    PriceCalculator.prototype.processForm = function(){
        $(config.overlayCloseBtnSelector).hide();
        return this.fetchFormValues();

    };

    PriceCalculator.prototype.calculateAll = function(formValues){

        var _this = this;
        var formValues = formValues;

        var calculateAllPromise = Utils.createPromise();

        $.ajax({
            type: "POST",
            url: $(config.calculateFormSelector).find('form').attr('action'),
            data: {"data": JSON.stringify({
                    "form": formValues,
                    "data": this.favourtiesStore.getFavourites()
                })}
        }).done(function( data ) {

            if ( data.status === 1 ) {
                _this.processAndUpdateFavourites(data.response);
            }

            if ( data.status === 0 ) {
                $('#failed-row').show();
                if ( !!data.response.type ) {
                    $('#failed-row .' + data.response.type).show();
                    $(config.errorAreaTooLargeEmailId).html(data.response.email);
                }
                $(config.overlayCloseBtnSelector).show();
            }

            calculateAllPromise.resolve();

        }).fail(function( data ) {
            $('#failed-row').show();
            $('#failed-row .error-no-default').show();
            $(config.overlayCloseBtnSelector).show();
            calculateAllPromise.reject();
        })

        return calculateAllPromise;

    }

    PriceCalculator.prototype.reCalculateAll = function(){

        var _this = this;

        var fav = this.favourtiesStore.getFavourites()

        var formValues = {
            "country": {
                "id": "country",
                "value": fav.dashboard.country
            },
            "area": {
                "id": "area",
                "value": fav.dashboard.size
            },
            "zip": {
                "id": "zip",
                "value": fav.dashboard.zip
            }
        };

        var calculateAllPromise = Utils.createPromise();

        $.ajax({
            type: "POST",
            url: $(config.calculateFormSelector).find('form').attr('action'),
            data: {"data": JSON.stringify({
                    "form": formValues,
                    "data": this.favourtiesStore.getFavourites()
                })}
        }).done(function( data ) {

            if ( data.status === 1 ) {
                _this.processAndUpdateFavourites(data.response);
            }

            // if ( data.status === 0 ) {
            //     $('#failed-row').show();
            //     if ( !!data.response.type ) {
            //         $('#failed-row .' + data.response.type).show();
            //         $(config.errorAreaTooLargeEmailId).html(data.response.email);
            //     }
            //     $(config.overlayCloseBtnSelector).show();
            // }

            calculateAllPromise.resolve();

        }).fail(function( data ) {
            $('#failed-row').show();
            $('#failed-row .error-no-default').show();
            $(config.overlayCloseBtnSelector).show();
            calculateAllPromise.reject();
        })

        return calculateAllPromise;

    }

    PriceCalculator.prototype.fetchFormValues = function(){

        var _this = this;

        var returnObj = {};

        $(config.calculateFormSelector + ' input').each(function (index, element) {

            if ( $(element).attr('type') != 'hidden' && $(element).attr('type') == 'number' ) {

                if ( $(element).val() ) {
                    returnObj[index] = {id: ( !!$(element).attr('id') ) ? $(element).attr('id') : 'country', value: $(element).val()};
                } else {
                    $(element).closest('input-field').addClass('input-field--error');
                }

            }

        });

        returnObj['country'] = {id: 'country', value: $('#country').get(0).options[$('#country')[0].selectedIndex].value};

        // var fullCountry =  $('#country').get(0).options[$('#country')[0].selectedIndex].text;
        // returnObj['countryFull'] = {id: 'fullCountry', value: fullCountry.toLowerCase()};

        return returnObj;

    }

    PriceCalculator.prototype.processAndUpdateFavourites = function(response){

        var _this = this;

        this.favourtiesStore.setFavourites(response);
        var favourites = this.favourtiesStore.getFavourites();

        $('.favourites__tabs__content').each( function (index, element) {
            if ( $(this).attr('data-favourite-node-type') == 'product') {
                $(this).attr('data-favourite-tab-items', JSON.stringify(favourites['content']['products']))
            }
        });

        favourites.general.prices = true;

        this.favourtiesStore.setFavourites(favourites);

        if ( config.singleCalculation ) {

            _this.postCalculateSingle(favourites);
            _this.processTerminForm(favourites);
            _this.emit('favourites:calculated', true);

        } else {

            _this.processTerminForm(favourites);

            $(config.overlayCloseBtnSelector).show();

            _this.emit('favourites:calculated', false);
        }


    }

    PriceCalculator.prototype.postCalculateSingle = function(favourites){
        const getPriceComponents = cumulatedPrice => {
            const priceComponents = cumulatedPrice.split(' ');
            if (priceComponents.length === 0) {
                return {
                    price: cumulatedPrice,
                    currency: ''
                }
            }

            const currency = priceComponents[0];
            delete priceComponents[0];
            const priceWithoutCurrency = priceComponents.join(' ');

            return {
                price: priceWithoutCurrency.trim(),
                currency: currency
            }
        }

        $.each(favourites['content']['products'], function (index, value) {
            if ( value.identifier == config.currentIdentifier ) {

                if ( value.many ) {

                    var template = $('#comment-template').html();
                    var compiledTemplate = _.template(template);
                    var $additionalMarkupTpl = $('.rowRangeOther');

                    if ( value.hasOwnProperty('individualPrices') ) {

                        var additionalMarkup = '';

                        $.each(value['individualPrices'], function (index, value) {
                            const rangeArea = getPriceComponents(value.qmRange);
                            const rangePrice = getPriceComponents(value.price);
                            var templateResult = compiledTemplate({
                                index: value.woodIndex,
                                qmRange: rangeArea.price,
                                character: value.woodIndex + ', ' + gradingScale[value.gradingScale],
                                price: rangePrice.price
                            });
                            additionalMarkup += templateResult;
                        });
                        $additionalMarkupTpl.html(additionalMarkup);

                    }

                    $(config.calculateOverlayRangeSelector).find('.range-qm-value').text(value.qmRange);
                    $(config.calculateOverlayRangeSelector).find('.range-price-value').text(value.price);
                    $(config.calculateOverlaySelector).find('.favourites__action__wrapper').attr('data-fav-qm-value', value.qmRange);
                    $(config.calculateOverlaySelector).find('.favourites__action__wrapper').attr('data-fav-price-value', value.price);
                    $(config.calculateOverlaySelector).find('.favourites__action__wrapper').attr('data-fav-many-value', value.many);

                } else {
                    $.each(value['individualPrices'], function (index, value) {
                        $(config.calculateOverlayRangeSelector).find('.character-value').text(value.woodIndex + ', ' + gradingScale[value.gradingScale])
                    });
                }

                const rangeArea = getPriceComponents(value.qmRange);
                const rangePrice = getPriceComponents(value.price);
                $(config.calculateOverlayRangeSelector).find('th .currency').text(`[${rangeArea.currency}]`);
                $(config.calculateOverlayRangeSelector).find('.range-qm-value').text(rangeArea.price);
                $(config.calculateOverlayRangeSelector).find('.range-price-value').text(rangePrice.price);
                $(config.calculateOverlaySelector).find('.favourites__action__wrapper').attr('data-fav-qm-value', value.qmRange);
                $(config.calculateOverlaySelector).find('.favourites__action__wrapper').attr('data-fav-price-value', value.price);
                $(config.calculateOverlaySelector).find('.favourites__action__wrapper').attr('data-fav-many-value', value.many);

                $(config.overlayCloseBtnSelector).show();
                $(config.calculateOverlayRangeSelector).show();


            }

        });

    };

    PriceCalculator.prototype.processTerminForm = function(favourites){

        $("input[id$='favourite-id']").val(favourites.general.code);
        $("input[id$='favourite-value']").val(JSON.stringify(favourites));

        var fullCountry =  $($('#country').get(0).options[$('#country')[0].selectedIndex]).attr('data-country-fullname');
        var $countrySelect = $("[id$='-country']");

        $countrySelect.val(fullCountry.toLowerCase());
        $countrySelect.material_select();

        $("input[id$='-zip']").val(favourites['dashboard']['zip']);
        $("input[name$='[zip]']").parent().find('label').addClass('active');
        $("input[id$='-area']").val(favourites['dashboard']['size']);
        $("input[name$='[area]']").parent().find('label').addClass('active');

        var $locationZipInput = $("input[id='favourites-finder-area']");
        $locationZipInput.val(favourites['dashboard']['zip']);
        $locationZipInput.parent().find('label').addClass('active');

    }

    PriceCalculator.prototype.processTerminMapLinks = function(code){

        var links = $('#terminOverlay').find('a.box--map');

        if ( links.length == 0) {
            return;
        }

        $(links).each( function (index, element) {

            var newUrl = Utils.removeURLParameter($(element).attr('href'), 'm');
            newUrl = Utils.addQueryStringParamsToUrl('m', code, newUrl)

            $(element).attr('href', newUrl);

        });

    }

    PriceCalculator.prototype.verifyFormFields = function() {

        const countrySelect = document.getElementById('country');
        const zipInput = document.getElementById('zip');
        const areaInput = document.getElementById('area');
        var $errorWrapperDiv = $(config.failedRowWrapper);
        var $errorAreaTooLarge = $(config.errorAreaTooLarge);

        const countryInputField = countrySelect.closest('.input-field');
        if (countrySelect.value == 'select') {
            countryInputField.classList.add('input-field--error');
        } else {
            countryInputField.classList.remove('input-field--error');
        }

        const zipInputField = zipInput.closest('.input-field');
        if (zipInput.value == '') {
            zipInput.classList.add('invalid')
            zipInput.classList.remove('valid')
            zipInputField.classList.add('input-field--error');
        } else {
            zipInput.classList.remove('invalid')
            zipInput.classList.add('valid')
            zipInputField.classList.remove('input-field--error')
        }

        if (areaInput.value >= 10 && areaInput.value < 401) {
            areaInput.classList.remove('invalid')
            areaInput.classList.add('valid')
            areaInput.parentElement.classList.remove('input-field--error')

            $errorWrapperDiv.hide();
            $errorAreaTooLarge.hide();
        } else {
            areaInput.classList.add('invalid')
            areaInput.classList.remove('valid')
            areaInput.parentElement.classList.add('input-field--error')

            const selectedMail = config.errorAreaTooLargeEmailId +  ' span.'+countrySelect.value;
            $(config.errorAreaTooLargeEmailId +  ' span').hide();
            $(selectedMail).show();
            $errorWrapperDiv.show();
            $errorAreaTooLarge.show();
        }

        const validFormFields = Array.from(document.querySelectorAll('#calculationForm .input-field--error'));
        return validFormFields.length > 0 ? false : true;
    }

    PriceCalculator.prototype.postCalulation = function(formValues){

        var _this = this;

    }


    return PriceCalculator;

});



// WEBPACK FOOTER //
// ./Private/Scripts/modules/priceCalculator/priceCalculator.js